var map = {
	"./at.svg": 7403,
	"./au.svg": 8346,
	"./bg.svg": 5821,
	"./ca.svg": 1372,
	"./de.svg": 3629,
	"./dk.svg": 1563,
	"./es.svg": 1760,
	"./fr.svg": 140,
	"./gb.svg": 9963,
	"./ie.svg": 2226,
	"./it.svg": 3395,
	"./lu.svg": 2325,
	"./nl.svg": 2674,
	"./no.svg": 8065,
	"./nz.svg": 4300,
	"./pl.svg": 6480,
	"./pt.svg": 9976,
	"./ro.svg": 4437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8854;